// import { Outlet, Navigate, useLocation } from 'react-router-dom';

// export const ProtectedRoute = ({ children, allowedRoles }) => {

// };
import { Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
const ProtectedRoute = ({ allowedRoles }) => {
  const user = localStorage.getItem("accessToken");
  // return <MainLayout />;
  if (user === null || user === undefined) {
    return <Navigate to={{ pathname: "/login" }} />;
  } else return <MainLayout />;
};

export default ProtectedRoute;
